import DataForm from "../Editor/DataForm";

export default class Record {

  constructor(resource, data, partial = false){
    this.resource = resource;
    this.data = null;
    this.form = null;
    this.error = null;
    this.busy = false;
    this.deleted = false;
    this.partial = partial;
    if(data){
      this._load(data);
    }
    this.editing = false;
    this.saved = false;
    this.hasError = false;
    this._onCreateListeners = [];
    this._onUpdateListeners = [];
    this._onSaveListeners = [];
    this._onDeleteListeners = [];
    this._onCancelListeners = [];
  }

  edit(){
    if(this.isPartial()){
      this.load().then(() => this.editing = true);
    }else{
      this.editing = true;
    }
  }

  isPartial(){
    return this.partial;
  }

  isDeleted(){
    return this.deleted;
  }

  isNew(){
    return !this.data.id;
  }

  isModified(){
    return this.form.modified;
  }

  isSaved(){
    return this.saved && !this.isModified();
  }

  cancel(){
    this._load(this.data);
    this._onCancelListeners.forEach(l => l(this))
  }

  load(){
    return this.resource.read(this.data.id).then(r => this._load(r.data)).then(() => this);
  }

  save(){
    this.busy = true;
    return this._save()
      .then(r => this._load(r.data))
      .then(() => {
        this.saved = true;
        this._onSaveListeners.forEach(l => l(this))
      }, (err) => {
        this.hasError = true;
        this.error = err;
        this.busy = false;
        throw err;
      })
      .then(() => this.busy = false)
      .then(() => this);
  }

  del(){
    this.busy = true;
    return this.resource.del(this.data.id)
      .then(() => {
        this.deleted = true;
        this.busy = false;
        this._onDeleteListeners.forEach(l => l(this))
        return this;
      }, (err) => {
        this.hasError = true;
        this.error = err;
        throw err;
      });
  }

  update(dto){
    this.resource.update(this.data.id, dto).then( record => {
      this._onUpdateListeners.forEach(l => l(record));
      return record;
    }).then(r => this._load(r.data));
  }

  call(method, params){
    return this.resource.call(method, params).then(result => this.load().then(() => result));
  }

  _save(){
    if(!this.isNew()){
      return this.resource.update(this.data.id, this.form.getUpdateDto()).then( record => {
        this._onUpdateListeners.forEach(l => l(record));
        return record;
      });
    }else{
      return this.resource.create(this.form.getUpdateDto()).then(record => {
        this._onCreateListeners.forEach(l => l(record));
        return record;
      });
    } 
  }

  _load(data){
    this.editing = false;
    this.saved = false;
    this.error = null;
    this.hasError = false;
    this.data = data;
    this.form = new DataForm(data, data.id ===  undefined);
  }

  field(fieldName){
    return this.form.field(fieldName);
  }

  onCreate(fn){
    this._onCreateListeners.push(fn);
  }

  onSave(fn){
    this._onSaveListeners.push(fn);
  }

  onUpdate(fn){
    this._onUpdateListeners.push(fn);
  }

  onDelete(fn){
    this._onDeleteListeners.push(fn);
  }

  onCancel(fn){
    this._onCancelListeners.push(fn);
  }

  getError(){
    return this.hasError && this.error;
  }

  hasFailed(){
    return this.hasError;
  }

  isWorking(){
    return this.busy;
  }

}


// WEBPACK FOOTER //
// ./src/Resource/Record.js